if (!customElements.get('sticky-product-bar')) {
  customElements.define(
    'sticky-product-bar',
    class StickyProductBar extends HTMLElement {
      constructor() {
        super();
        this.sectionId = this.dataset.section;
        this.realButton = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
        this.realPrice = document.getElementById(`price-${this.sectionId}`);
        this.stickyButton = this.querySelector('[data-sticky-submit]');
        this.stickyButtonText = this.stickyButton?.querySelector('span');
        this.stickyPrice = this.querySelector('[data-sticky-price]');
        this.mediaQuery = window.matchMedia('(max-width: 749px)');
      }

      connectedCallback() {
        if (!this.realButton || !this.stickyButton) return;

        this.removeAttribute('hidden');

        this.stickyButton.addEventListener('click', () => {
          if (this.realButton.getAttribute('aria-disabled') === 'true' || this.realButton.disabled) return;
          this.realButton.click();
        });

        this.syncButtonState();
        this.buttonObserver = new MutationObserver(this.syncButtonState.bind(this));
        this.buttonObserver.observe(this.realButton, {
          attributes: true,
          attributeFilter: ['disabled', 'aria-disabled'],
          subtree: true,
          characterData: true,
          childList: true,
        });

        if (this.realPrice) {
          this.syncPrice();
          this.priceObserver = new MutationObserver(this.syncPrice.bind(this));
          this.priceObserver.observe(this.realPrice, { childList: true, subtree: true });
        }

        this.handleMediaChange = this.handleMediaChange.bind(this);
        this.mediaQuery.addEventListener('change', this.handleMediaChange);
        this.handleMediaChange(this.mediaQuery);
      }

      disconnectedCallback() {
        this.buttonObserver?.disconnect();
        this.priceObserver?.disconnect();
        this.visibilityObserver?.disconnect();
        this.mediaQuery.removeEventListener('change', this.handleMediaChange);
      }

      handleMediaChange(event) {
        if (event.matches) {
          this.initVisibilityObserver();
        } else {
          this.visibilityObserver?.disconnect();
          this.classList.remove('sticky-product-bar--visible');
        }
      }

      initVisibilityObserver() {
        if (this.visibilityObserver) return;
        this.visibilityObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              this.classList.toggle('sticky-product-bar--visible', !entry.isIntersecting);
            });
          },
          { rootMargin: '0px 0px -10% 0px' }
        );
        this.visibilityObserver.observe(this.realButton);
      }

      syncButtonState() {
        const disabled = this.realButton.disabled || this.realButton.getAttribute('aria-disabled') === 'true';
        this.stickyButton.disabled = disabled;
        this.stickyButton.classList.toggle('loading', this.realButton.classList.contains('loading'));

        const realText = this.realButton.querySelector('span')?.textContent?.trim();
        if (realText && this.stickyButtonText) this.stickyButtonText.textContent = realText;
      }

      syncPrice() {
        if (this.realPrice && this.stickyPrice) this.stickyPrice.innerHTML = this.realPrice.innerHTML;
      }
    }
  );
}
